import classNames from 'classnames'
import type { FC } from 'react'
import React from 'react'
import styles from './NavigationMenuDrawer.module.scss'
import { CrossIcon, IconButton, IconButtonSize, IconButtonVariants } from '@/tools/ui'

type Props = {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export const NavigationMenuDrawer: FC<Props> = ({ isOpen, onClose, children }) => {
  const handleCloseMenu = () => {
    onClose()
  }

  return (
    <div
      className={classNames({
        [styles.navigationMenuDrawer]: true,
        [styles.open]: isOpen,
        [styles.closed]: !isOpen,
      })}
    >
      <div className={styles.header}>
        <IconButton
          aria-label={'address-close'}
          className={styles.navigationMenuDismiss}
          icon={CrossIcon}
          size={IconButtonSize.small}
          variant={IconButtonVariants.neutral}
          onClick={handleCloseMenu}
        />
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
